import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useEffect } from "react";
import axios from "axios";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import "./ManagementModal.scss";
import { errorToast } from "../../common/ToastMessage";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

export default function ManagementViewModal({ open, close, managementid, managmentData, setLoaderActive }) {
    const [monitornameid, setMonitorNameId] = React.useState([]);
    const [cpunameid, setCPUNameId] = React.useState([]);
    const [keyboradnameid, setKeyBoradNameId] = React.useState([]);
    const [mousenameid, setMouseNameId] = React.useState([]);
    const [headphonenameid, setHeadPhoneNameId] = React.useState([]);
    const [cameranameid, setCameraNameId] = React.useState([]);
    const [brands, setBrands] = React.useState();


    useEffect(() => {
        window.scrollTo(0, 0);
        getAllData();
        getBrandName();
    }, [managementid]);

    const getAllData = async () => {
        // setLoaderActive(true);
        const headers = {
            Authorization: "Bearer " + localStorage.getItem("_token"),
            "Content-type": "application/json",
        };
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_ENDPOINT_PROD}/api/Management/GetAllAppliances`,
                {
                    headers: headers,
                }
            );
            setMonitorNameId(response?.data?.data?.moniter);
            setCPUNameId(response?.data?.data?.cpu);
            setKeyBoradNameId(response?.data?.data?.keyboard);
            setMouseNameId(response?.data?.data?.mouse);
            setHeadPhoneNameId(response?.data?.data?.headphone);
            setCameraNameId(response?.data?.data?.camera);
            setLoaderActive(false);
        } catch (error) {
            console.log(error);
            setLoaderActive(false);
            if (error?.response?.status === 401) {
                errorToast(error?.response?.statusText)
            } else {
                errorToast(error?.message)
            }
        }
    };

    const getBrandName = async () => {
        const headers = {
            Authorization: "Bearer " + localStorage.getItem("_token"),
            "Content-type": "application/json",
        };
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Appliance/GetBrandName`,
                {
                    headers: headers,
                }
            );
            setBrands(response.data.data);
        } catch (error) {
            console.log(error);
        }
    };
    const getLabelTextValue = (dataID, name) => {
        return dataID !== "" ? name : `No ${name} Selected`
    }
    const getBrandNameValue = (applianceData) => {
        const selectedBrand = brands?.find((item) => {
            return item?.brandId == applianceData?.brandId
        })
        return selectedBrand?.brandName
    }
    return (
        <div>
            <BootstrapDialog
                className="management-modal-wrap modal-wrap"
                onClose={() => close()}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <BootstrapDialogTitle
                    id="customized-dialog-title"
                    onClose={() => close()}
                >
                    View User
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="txtfield-wrap">
                                <TextField
                                    fullWidth
                                    label=" Name"
                                    value={managmentData?.employeeName}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="txtfield-wrap">
                                <TextField
                                    fullWidth
                                    label=" E-Mail ID"
                                    value={managmentData?.employEmailId}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="txtfield-wrap">
                                <TextField
                                    fullWidth
                                    label="Assigned Project"
                                    value={managmentData?.assignProjectName}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="txtfield-wrap">
                                <LocalizationProvider dateAdapter={AdapterDayjs} sx={{ width: "100%" }}>
                                    <MobileDatePicker
                                        fullWidth
                                        label="Date of Provided Appliances"
                                        inputFormat="DD/MM/YYYY"
                                        value={managmentData?.dateOfIssue}
                                        onChange={() => { }}
                                        renderInput={(params) => <TextField {...params} />}
                                        disabled
                                    />
                                </LocalizationProvider>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="txtfield-wrap">
                                <TextField
                                    fullWidth
                                    label="Password"
                                    value={managmentData?.password}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="txtfield-wrap">
                                <TextField
                                    fullWidth
                                    label="Designation"
                                    value={managmentData?.designation}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="txtfield-wrap">
                                <FormControl fullWidth
                                    sx={{
                                        "& .MuiOutlinedInput-root": { mb: 2 },
                                    }}>
                                    <InputLabel id="demo-simple-select-label"> {getLabelTextValue(managmentData?.monitorId, "Monitor")}</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label=" Monitor"
                                        value={managmentData?.monitorId}
                                        disabled
                                    >
                                        {monitornameid && monitornameid.map((item, i) => {
                                            return (
                                                <MenuItem key={`monitor-${i + 1}`} value={item?.applianceId} className={item?.isAssign == 0 ? "occupied" : "unoccupied"} disabled={item?.isAssign == 0 ? false : true}>{item?.applianceCode} - {getBrandNameValue(item)}</MenuItem>
                                            )
                                        })}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="txtfield-wrap">
                                <FormControl fullWidth
                                    sx={{
                                        "& .MuiOutlinedInput-root": { mb: 2 },
                                    }}>
                                    <InputLabel id="demo-simple-select-label">{getLabelTextValue(managmentData?.cpuId, "CPU")}</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="CPU"
                                        value={managmentData?.cpuId}
                                        disabled
                                    >
                                        {cpunameid && cpunameid.map((item, i) => {
                                            return (
                                                <MenuItem key={`cpu-${i + 1}`} value={item?.applianceId} className={item?.isAssign == 0 ? "occupied" : "unoccupied"} disabled={item?.isAssign == 0 ? false : true}>{item?.applianceCode} - {getBrandNameValue(item)}</MenuItem>
                                            )
                                        })}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="txtfield-wrap">
                                <FormControl fullWidth
                                    sx={{
                                        "& .MuiOutlinedInput-root": { mb: 2 },
                                    }}>
                                    <InputLabel id="demo-simple-select-label">{getLabelTextValue(managmentData?.keybordId, "Key Board")}</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Key Board"
                                        value={managmentData?.keybordId}
                                        disabled
                                    >
                                        {keyboradnameid && keyboradnameid.map((item, i) => {
                                            return (
                                                <MenuItem key={`keyboard-${i + 1}`} value={item?.applianceId} className={item?.isAssign == 0 ? "occupied" : "unoccupied"} disabled={item?.isAssign == 0 ? false : true}>{item?.applianceCode} - {getBrandNameValue(item)}</MenuItem>
                                            )
                                        })}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="txtfield-wrap">
                                <FormControl fullWidth
                                    sx={{
                                        "& .MuiOutlinedInput-root": { mb: 2 },
                                    }}>
                                    <InputLabel id="demo-simple-select-label">{getLabelTextValue(managmentData?.mouseId, "Mouse")}</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Mouse"
                                        value={managmentData?.mouseId}
                                        disabled
                                    >
                                        {mousenameid && mousenameid.map((item, i) => {
                                            return (
                                                <MenuItem key={`mouse-${i + 1}`} value={item?.applianceId} className={item?.isAssign == 0 ? "occupied" : "unoccupied"} disabled={item?.isAssign == 0 ? false : true}>{item?.applianceCode} - {getBrandNameValue(item)}</MenuItem>
                                            )
                                        })}

                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="txtfield-wrap">
                                <FormControl fullWidth
                                    sx={{
                                        "& .MuiOutlinedInput-root": { mb: 2 },
                                    }}>
                                    <InputLabel id="demo-simple-select-label">{getLabelTextValue(managmentData?.headphoneId, "Head Phone")}</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Head Phone"
                                        value={managmentData?.headphoneId}
                                        disabled
                                    >
                                        {headphonenameid && headphonenameid.map((item, i) => {
                                            return (
                                                <MenuItem key={`headphone-${i + 1}`} value={item?.applianceId} className={item?.isAssign == 0 ? "occupied" : "unoccupied"} disabled={item?.isAssign == 0 ? false : true}>{item?.applianceCode} - {getBrandNameValue(item)}</MenuItem>
                                            )
                                        })}

                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="txtfield-wrap">
                                <FormControl fullWidth
                                    sx={{
                                        "& .MuiOutlinedInput-root": { mb: 2 },
                                    }}>
                                    <InputLabel id="demo-simple-select-label">{getLabelTextValue(managmentData?.cameraId, "Camera")}</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Camera"
                                        value={managmentData?.cameraId}
                                        disabled
                                    >
                                        {cameranameid && cameranameid.map((item, i) => {
                                            return (
                                                <MenuItem key={`camera-${i + 1}`} value={item?.applianceId} className={item?.isAssign == 0 ? "occupied" : "unoccupied"} disabled={item?.isAssign == 0 ? false : true}>{item?.applianceCode} - {getBrandNameValue(item)}</MenuItem>
                                            )
                                        })}

                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions className="btns-wrapper">
                    <Stack spacing={4} direction="row" className="bottom-btn-wrap">
                        <Button variant="outlined" onClick={() => close()}>Cancel</Button>
                    </Stack>
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}
